module.exports = __webpack_public_path__ + "static/media/t-posed.e6c94f37.png";